import {
  PolicyServer,
  ProductType,
  ProductServer,
  ProductVariant,
  ProductVariantServer,
  VehicleState,
  PersonalDetailType,
  DirectDebitDetails
} from '../common/CommonTypes';
import {
  getSelectedProducts,
  getSelectedVariant
} from '../common/ProductMethods';
import { getFormattedDate, getIsoDate } from '../common/HelperMethods';
import { PaymentMethod } from '../common/Constants';
import { PaymentDay } from '../../consts/Common';

export const getPolicyServer = (
  paymentMethod: string,
  cardTransactionId: string,
  products: ProductType[],
  vehicle: VehicleState,
  personalDetail: PersonalDetailType,
  directDebitDetails: DirectDebitDetails,
  policyStartDate: string,
  isLateRenewal: boolean,
  dealerCode: string,
  journeyId: string,
  salesId: string,
  useWorldPay: boolean,
  noOfInstallments: number | undefined,
  renewalConsent: boolean
): PolicyServer | undefined => {
  const productsToRegister = getProductsServer(
    products,
    paymentMethod,
    policyStartDate,
    noOfInstallments
  );

  if (!productsToRegister || productsToRegister.length == 0) {
    return undefined;
  }

  const defaultVehicleDeliveryDate = new Date().toLocaleDateString('en-GB');

  const policy: PolicyServer = {
    dealerNumber: dealerCode,
    vrn: vehicle.vehicleDetails.vrn,
    vin: vehicle.vehicleDetails.vin || '',
    purchaseDistance: vehicle.currentMileage || 0,
    vehiclePurchasePrice: vehicle.vehiclePurchasePrice,
    dateFirstRegistration: vehicle.vehicleDetails.registrationDate,
    vehiclePurchaseDate:
      vehicle.vehicleDeliveryDate === undefined
        ? defaultVehicleDeliveryDate
        : getFormattedDate(vehicle.vehicleDeliveryDate),
    title: personalDetail.title,
    firstName: personalDetail.firstName,
    lastName: personalDetail.surname,
    dateOfBirth: getIsoDate(personalDetail.dateOfBirth),
    email: personalDetail.email,
    phoneHome: personalDetail.phone,
    phoneMobile: '',
    phoneWork: '',
    addressLine1: personalDetail.addressDetails.addressLine1 || '',
    addressLine2: personalDetail.addressDetails.addressLine2 || '',
    cityTown: personalDetail.addressDetails.townOrCity || '',
    postalCode: personalDetail.addressDetails.postCode || '',
    gapIntroductionDate: getFormattedDate(vehicle.vehicleGapIntroductionDate),
    paymentMethod: paymentMethod,
    bankSortCode: `${directDebitDetails.sortCode1 || ''}${directDebitDetails.sortCode2 || ''}${directDebitDetails.sortCode3 || ''}`,
    accHolderName: directDebitDetails.accountHolderName,
    bankAccountNumber: directDebitDetails.accountNumber || '',
    bankName: directDebitDetails.bankName || '',
    paymentReference:
      paymentMethod === PaymentMethod.Monthly ? '' : cardTransactionId,
    products: productsToRegister,
    brand: getBrand(),
    journeyId: journeyId,
    preferredPaymentDay: getPreferredPaymentDay(
      paymentMethod,
      directDebitDetails.selectedPaymentDay
    ),
    modelTrimId: vehicle.vehicleDetails.modelTrimId,
    salesId: salesId,
    isLateRenewal: isLateRenewal,
    useWorldPay: useWorldPay,
    renewalConsent: renewalConsent
  };
  console.log('cardTransactionId', cardTransactionId);
  console.log('paymentreference', policy.paymentReference);

  return policy;
};

const getProductsServer = (
  products: ProductType[],
  paymentMethod: string,
  policyStartDate: string,
  noOfInstallments: number | undefined
): ProductServer[] => {
  const selectedProducts = getSelectedProducts(products);

  const serverProducts: ProductServer[] = [];

  selectedProducts.forEach((p) => {
    const selectedVariant = getVariantsServer(
      p.productVariants,
      paymentMethod,
      noOfInstallments
    );

    if (selectedVariant && selectedVariant.length > 0) {
      serverProducts.push({
        productTypeId: p.productTypeId,
        productName: p.productName,
        policyStartDateLimit: p.policyStartDateLimit,
        productVariants: selectedVariant,
        policyStartDate: getFormattedDate(p.policyStartDate ?? policyStartDate),
        isVariablePrice: p.isVariablePrice
      });
    }
  });

  return serverProducts;
};

const getVariantsServer = (
  variants: ProductVariant[],
  paymentMethod: string,
  noOfInstallments: number | undefined
): ProductVariantServer[] => {
  const selectedVariant = getSelectedVariant(variants);

  let serverVariants: ProductVariantServer[] = [];

  if (
    selectedVariant?.paymentMethod == paymentMethod &&
    (typeof noOfInstallments == 'undefined' ||
      selectedVariant?.noOfInstallments == noOfInstallments)
  ) {
    serverVariants = [
      {
        variantId: selectedVariant?.variantId || '',
        duration: selectedVariant?.duration || '',
        price: selectedVariant?.price || 0,
        noOfInstallments: selectedVariant?.noOfInstallments || 0,
        paymentMethod: selectedVariant?.paymentMethod || '',
        warrantyTierId: selectedVariant?.warrantyTierId || 0
      }
    ];
  }

  return serverVariants;
};

const getPreferredPaymentDay = (
  paymentMethod: string,
  selectedPayDay: string
): number => {
  if (paymentMethod === PaymentMethod.Subscription) {
    return parseInt(PaymentDay.Empty);
  } else {
    return selectedPayDay === PaymentDay.Empty
      ? parseInt(PaymentDay.Default)
      : parseInt(selectedPayDay);
  }
};

const getBrand = () => {
  const urlDestructured = window.location.host.split('.');
  const brand = urlDestructured[0];

  return brand;
};
